<template>
    <div id="app">
        <router-view name="navbar" />

        <router-view class="main" :class="{'logged-in': user.id && !hide_navbar, 'dark-mode': dark_mode}" />

        <vue-progress-bar />

    </div>
</template>

<style lang="scss">
@import "@/assets/css/_colors.scss";

.main {
    min-height: 100vh;

    &.logged-in {
        padding-top: 55px;
    }

    &.dark-mode {

    }
}
</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        hide_navbar: false
    }),
    components: {
        
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            dark_mode: state => state.utilities.dark_mode
        })
    },
    watch: {
        '$route' (to) {
            let title = null

            if (to.meta.title) {
                title = to.meta.title
            }

            if (to.meta.hideNavbar) {
                this.hide_navbar = true
            }

            document.title = title
        }
    },
    methods: {}
}
</script>
